/** biome-ignore-all lint/suspicious/noExplicitAny: TODO: fix */
import { createProvider } from '@nvision/services/data-provider';
import { infiniteQueryOptions } from '@tanstack/react-query';

import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';

import type { TariffsSearchParams } from '../../models';
import { CACHE_KEYS } from '../../types';
import { logger } from '../../utils/logger';
import * as api from './api';

export const fetchTariffs = createProvider(api.fetchTariffs)
  .andThen((res) => res)
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      logger.warn('Fetch tariffs is aborted');
    } else {
      showNotification({ message: 'Fetch tariffs was failed', type: NOTIFICATION_TYPES.ERROR });
      logger.error(`Fetch tariffs was failed: ${error}`);
    }
    throw error;
  });

export const TARIFFS_PAGE_SIZE = 10;

export const tariffsInfiniteQueryOptions = (filters: TariffsSearchParams) =>
  // biome-ignore assist/source/useSortedKeys: TODO: wait for tanstack query update
  infiniteQueryOptions({
    initialPageParam: 0,
    queryFn: ({ pageParam, signal }) =>
      fetchTariffs({ ...filters, skip: pageParam, take: TARIFFS_PAGE_SIZE }, { signal }),
    queryKey: CACHE_KEYS.tariffs(filters),
    getNextPageParam: (lastPage, allPages) => {
      const loadedCount = allPages.reduce((count, page) => count + page.items.length, 0);

      return loadedCount < lastPage.totalCount ? loadedCount : undefined;
    },
    select: (data) => ({
      items: data.pages.flatMap((page) => page.items),
      totalCount: data.pages[0]?.totalCount ?? 0,
    }),
  });
